module.exports = __webpack_public_path__ + "img/1517851754.363a9ef5.jpg";